
let language = {
    PRODUCT_PROPERTY_FORM_ISSUE: "Product property Form Error",
    PRODUCT_PROPERTY_FORM_ISSUE_CONTENT: "Product property form error. Please try again later. If issues still persist, please contact {{supportmail}}",
    PRODUCT_PROPERTY_FORM_ISSUE_108000061: "Failed to find the corresponding property form address.",
    PRODUCT_PROPERTY_FORM_ISSUE_249962968: "The window object is not defined when loading the product property form.",
    PRODUCT_PROPERTY_FORM_ISSUE_249962969: "Authentication expired when loading the product property form.",
    PRODUCT_PROPERTY_FORM_ISSUE_249962976: "Session timeout when loading the product property form.",
    PRODUCT_PROPERTY_FORM_ISSUE_251113501: "Failed to initialize the product property form.",
    PRODUCT_PROPERTY_FORM_ISSUE_251113554: "Something went wrong while loading the product property form.",
    PRODUCT_PROPERTY_FORM_ISSUE_251113554_BY_EVENTID: "Something went wrong while loading the product property form. EventId:{{eventId}}",
    PRODUCT_PROPERTY_FORM_ISSUE_251216064: "The product property form itself is abnormal.",
    PRODUCT_PROPERTY_FORM_ISSUE_251216800: "The property form holds the propertyModel exception.",
    PRODUCT_PROPERTY_FORM_ISSUE_251216855: "The property form gets the property keyValue exception.",
    PRODUCT_PROPERTY_FORM_ISSUE_251216855_BY_EVENTID: "The property form gets the property keyValue exception. EventId:{{eventId}}",
    PRODUCT_PROPERTY_FORM_ISSUE_251217152: "The product property form is invalid.",
    PRODUCT_PROPERTY_FORM_ISSUE_251219155: "The product Property form Failed to create SKU product.",
};

export { language };